import { render } from "./ModalEditarLubrificante.vue?vue&type=template&id=761f2da4&scoped=true&ts=true"
import script from "./ModalEditarLubrificante.vue?vue&type=script&lang=ts"
export * from "./ModalEditarLubrificante.vue?vue&type=script&lang=ts"

import "./ModalEditarLubrificante.vue?vue&type=style&index=0&id=761f2da4&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761f2da4"]])

export default __exports__